import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {PasswordIcon} from "~/Components/Icons/Icons";

const AdminGuestPassword = ({invitation}) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const style = {
        width: '400px',
        margin: '50px auto 0 auto',
        padding: '5px',
        textAligh: 'center',
        border: '2px solid #999BB5',
        fontWeight: 500,
        textAlign: 'center'
    }

    return (
        <>
            <a href="#" onClick={handleShow}>
                <PasswordIcon />
            </a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Guest Access Code</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={style}>{invitation.code}</div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AdminGuestPassword;
